var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5129 20 20 15.5129 20 10C20 4.4871 15.5129 0 10 0C4.4871 0 0 4.4871 0 10C0 15.5129 4.4871 20 10 20ZM10 1.93548C14.4484 1.93548 18.0645 5.55161 18.0645 10C18.0645 14.4484 14.4484 18.0645 10 18.0645C5.55161 18.0645 1.93548 14.4484 1.93548 10C1.93548 5.55161 5.55161 1.93548 10 1.93548Z",
    fill: "#5981e9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1686 12.198L11.788 13.098C11.9332 13.1786 12.0944 13.2205 12.2557 13.2205C12.6073 13.2205 12.9332 13.0302 13.1041 12.7238C13.3622 12.256 13.1944 11.6657 12.7267 11.4076L11.1073 10.5076C10.6235 10.2367 10.3202 9.72699 10.3202 9.17215V6.45602C10.3202 5.92377 9.88477 5.48828 9.35251 5.48828C8.82025 5.48828 8.38477 5.92377 8.38477 6.45602V9.17215C8.38477 10.4302 9.06864 11.5915 10.1654 12.2012L10.1686 12.198Z",
    fill: "#5981e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.d6559d747a5e9bc320451a538b604c51.svg";
export { ForwardRef as ReactComponent };